import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import tr from './locales/tr.json';

export const LOCALE_STORAGE_KEY = 'rotary-locale';

/** @returns {'tr' | 'en'} */
function readStoredLocale() {
    try {
        const v = localStorage.getItem(LOCALE_STORAGE_KEY);
        if (v === 'en' || v === 'tr') return v;
    } catch {
        /* ignore */
    }
    return 'tr';
}

function applyDocumentLang(lng) {
    const short = lng && String(lng).toLowerCase().startsWith('en') ? 'en' : 'tr';
    document.documentElement.lang = short;
}

const initialLng = readStoredLocale();
applyDocumentLang(initialLng);

i18n.on('languageChanged', (lng) => {
    applyDocumentLang(lng);
    try {
        localStorage.setItem(
            LOCALE_STORAGE_KEY,
            lng && String(lng).toLowerCase().startsWith('en') ? 'en' : 'tr',
        );
    } catch {
        /* ignore */
    }
});

i18n.use(initReactI18next).init({
    resources: {
        tr: { translation: tr },
        en: { translation: en },
    },
    lng: initialLng,
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en'],
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
